import React, { createContext, useContext, useRef, useState } from 'react';

type ModalContextValue = {
  isPtwDetailModalOpen: boolean;
  setIsPtwDetailModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedApprovalType: string | null;
  setSelectedApprovalType: React.Dispatch<React.SetStateAction<string | null>>;
  autoOpenSignatureType: string | null;
  setAutoOpenSignatureType: React.Dispatch<React.SetStateAction<string | null>>;
  saveBeforeApproval: React.MutableRefObject<(() => Promise<boolean>) | null>;
};

const ModalContext = createContext<ModalContextValue | undefined>(undefined);

export function PtwDetailModalProvider({ children }: { children: React.ReactNode }) {
  const [isPtwDetailModalOpen, setIsPtwDetailModalOpen] = useState(false);
  const [selectedApprovalType, setSelectedApprovalType] = useState<string | null>(null);
  const [autoOpenSignatureType, setAutoOpenSignatureType] = useState<string | null>(null);
  const saveBeforeApproval = useRef<(() => Promise<boolean>) | null>(null);

  return React.createElement(
    ModalContext.Provider,
    {
      value: {
        isPtwDetailModalOpen,
        setIsPtwDetailModalOpen,
        selectedApprovalType,
        setSelectedApprovalType,
        autoOpenSignatureType,
        setAutoOpenSignatureType,
        saveBeforeApproval
      }
    },
    children
  );
}

export function usePtwDetailModal() {
  const ctx = useContext(ModalContext);
  if (!ctx) throw new Error('usePtwDetailModal must be used within PtwDetailModalProvider');
  return ctx;
}
